import React from 'react';
import { useStore } from '../../../../../stores/root';

// assets

// services

// props

// components
import { DefaultButton, Panel, PanelType, PrimaryButton, Spinner, SpinnerSize, Stack } from '@fluentui/react';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import Label from '../../../../typography/label';
import Text from '../../../../typography/text';
import GeneralService from '../../../../../services/general';
import { IOrderTruckResourceShortProps } from '../../../../../props/orders/trucks';
import OrderTruckService from '../../../../../services/orders/trucks';

interface DeleteOrderTruckFormProps {
    truck: IOrderTruckResourceShortProps;
    onDismissed(refresh?: boolean): void;
}

const DeleteOrderTruckForm: React.FC<DeleteOrderTruckFormProps> = (props: DeleteOrderTruckFormProps) => {
    const { banner } = useStore();
    const [submitting, setSubmitting] = React.useState<boolean>(false);

    const _onSubmit = async () => {
        try {
            setSubmitting(true);
            await OrderTruckService.delete(props.truck.orderId, props.truck.id);

            banner.add({
                key: 'delete_order_truck_success',
                variant: 'success',
                icon: faCheck,
                text: `Truck ${props.truck.name ? props.truck.name + " " : ""}deleted successfully`
            });
            props.onDismissed(true);
        } catch (e) {
            setSubmitting(false);
        }
    }

    return <Panel headerText={"Delete Truck"}
        isOpen={true}
        type={PanelType.medium}
        onDismiss={() => props.onDismissed(false)}
        isFooterAtBottom={true}
        onRenderFooterContent={() => {
            return <Stack horizontal tokens={{ childrenGap: 10 }}>
                {
                    !submitting ? (
                        <>
                            <PrimaryButton text={"Delete"} onClick={_onSubmit} />
                            <DefaultButton text={"Cancel"} onClick={() => { props.onDismissed(false) }} />
                        </>
                    ) : null
                }
                {submitting ? <Spinner size={SpinnerSize.medium} labelPosition={"right"} label={"Deleting truck ..."} /> : null}
            </Stack>;
        }}>
        <Stack tokens={{ childrenGap: 15 }} styles={{ root: { marginTop: 20 } }}>
            <Text>Are you sure you want to delete truck with details below?</Text>
            <Stack.Item>
                <Label>Name</Label>
                <Text>{props.truck.name || "-"}</Text>
            </Stack.Item>
            <Stack.Item>
                <Label>Price</Label>
                <Text>Rp. {GeneralService.getNumberWithSeparator(Number(props.truck.totalPrice))}</Text>
            </Stack.Item>
        </Stack>
    </Panel>
};

export default DeleteOrderTruckForm;
